import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleTaskUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      fill="none"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={28} cy={28} r={28} fill="#999" />
      <rect x={16} y={16} width={24} height={26} rx={1.5} fill="#fff" />
      <rect
        x={21.25}
        y={11.25}
        width={13.5}
        height={6.5}
        rx={1.75}
        fill="#CCC"
        stroke="#999"
        strokeWidth={1.5}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 24.25a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm13 .85a.5.5 0 00.5-.5v-.7a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5v.7c0 .28.22.5.5.5h11zm0 4.5a.5.5 0 00.5-.5v-.7a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5v.7c0 .28.22.5.5.5h11zm-14.25.4a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
        fill="#999"
      />
      <circle cx={38} cy={36} r={9} fill="#CCC" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.86 33.26c.2.2.2.51 0 .7l-5.5 5.5a.5.5 0 01-.7 0l-3.5-3.5a.5.5 0 010-.7l.7-.7c.2-.2.51-.2.7 0l2.45 2.43 4.44-4.44c.2-.2.5-.2.7 0l.71.71z"
        fill="#fff"
      />
    </svg>
  );
}

SvgPicCircleTaskUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleTaskUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleTaskUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
